import { ACCENT_COLOR, PRIMARY_COLOR } from '@/constants';
import { useAuth } from '@/contexts/Auth';

export const useColors = () => {
    const { brand } = useAuth();

    const primaryColor = brand?.color || PRIMARY_COLOR;
    const accentColor = brand?.accent || ACCENT_COLOR;

    return { primaryColor, accentColor };
};
